import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  useMediaQuery,
  Grid,
  Typography,
  TextField,
  Divider,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  value: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  updateContact: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
  },
}));

const General = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const { user } = useSelector(state => state.user);

  return (
    <div className={className} {...rest}>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12}>
          <Typography variant="h6" color="textPrimary">
            Basic Information
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            Full Name
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.firstName} {user.lastName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            Employee Number
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.employeeNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            E-mail
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.email}
          </Typography>
        </Grid>
        {
          user.county && user.state && (
            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                className={classes.title}
              >
                Work Location
              </Typography>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                className={classes.value}
              >
                {`${user.county} ${user.state}`.trim()}
              </Typography>
            </Grid>
          )
        }
        {/*<Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            Phone Number
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.phone}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            Employer
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.employer}
          </Typography>
        </Grid> */}
        {/* <Grid item xs={12}>
          <Divider />
        </Grid> */}
        {/* <Grid item xs={12}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            Full Address
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.address}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            City
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.city}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.title}
          >
            State
          </Typography>
          <Typography
            variant="subtitle1"
            color="textPrimary"
            className={classes.value}
          >
            {user.state}
          </Typography>
        </Grid> */}


      </Grid>
      <div className={classes.updateContact}>
        <Typography variant="subtitle2">
          To update your contact information, go to GMR People Services and select Contact Info Update: &nbsp;
          <a target="_blank" rel="noopener noreferrer" href="https://gmrcorp.service-now.com/gps">
              GMR People Services
          </a>
        </Typography>
      </div>
    </div>
  );
};

General.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default General;
